export const SurveyAnswersButton = {
  Summary: 'summary',
  Question: 'question',
  Respondent: 'respondent',
} as const;

export type SurveyAnswersButtonValues = (typeof SurveyAnswersButton)[keyof typeof SurveyAnswersButton];
